{ Jadelet, Modal, Observable } from @danielx/dui

{ floatToPan, panToFloat } from @danielx/lib

{DEFAULT_SPRITE_SHA} from ../const.civet

Template := Jadelet.exec """
section.settings
  h2 Settings
  button.close(click=@close) X
  label.inline
    h3 SoundFont
    select.synth(value=@synthSha)
      @synthOptions
  br
  label.inline
    h3 Spritesheet
    select.sprite(value=@spriteSha)
      @spriteOptions
  button.flat(click=@showThemeModal style="margin-left: 8px") Edit Theme
  table
    thead
      tr
        th Sprite
        th Channel
        th.solo
          button.flat(click=@unmuteAll) Unmute All
        th Instrument
        th Volume
        th Pan
    tbody
      @items
"""

// TOLATER: remove channel mapping / reset to automatic mode
// button(click=@removeChannelMapping) Automatic

ChannelSpritePickerTemplate := Jadelet.exec """
  section.channel-sprite(@class)
    h2
      | Pick Sprite for channel
      span.channel @ch
    div
      @options
"""

SpriteOptionTemplate := Jadelet.exec """
  tool(@class @click)
"""

###

  td.input
    input(type="range" min=-12 max=12 step=1 value=@pitchShift)
    input(type="number" min=-12 max=12 step=1 value=@pitchShift)
###

RowTemplate := Jadelet.exec """
tr
  td.sprite
    tool(class=@channelSprite click=@chooseSprite)
  td.channel
    label
      input(type="checkbox" checked=@active)
      @name
  td.solo
    button(click=@soloChannel) Solo
  td
    select(value=@program)
      @programOptions
  td.input
    .slider
      input(type="number" min=0 max=1 step=0.01 value=@volume)
      input(type="range"  min=0 max=1 step=0.01 value=@volume)
  td.input
    .slider
      input(type="number" min=-1 max=1 step=0.02 value=@pan)
      input(type="range"  min=-1 max=1 step=0.02 value=@pan)

"""

OptionTemplate := Jadelet.exec """
  option(@value) @name
"""

RowView := (model) ->

  element: RowTemplate model
  active: model.active

export Settings := (player: Player) ->
  player.showSettings ?= ->
    Modal.show self.element

  spriteSha := Observable DEFAULT_SPRITE_SHA
  spriteSha.observe (sha) ->
    if sha
      player.loadSpritesheetFromSha sha
  player.song.spriteSha.observe (sha) ->
    spriteSha sha

  synthSha := Observable null
  synthSha.observe (sha) ->
    player.setSynthBySha sha
  player.song.synthSha.observe (sha) ->
    synthSha sha

  spritePickerChannel := Observable null

  showSpritePicker := (c) ->
    spritePickerChannel(c)
    Modal.show channelSpritePicker

  channelSpritePicker := ChannelSpritePickerTemplate
    ch: ->
      spritePickerChannel() + 1
    removeChannelMapping: ->
      player.song.removeChannelSprite spritePickerChannel()
      // Return to showing settings
      Modal.show self.element
    options: ->
      player.spriteTextures().map (t, i) ->
        SpriteOptionTemplate
          class: ->
            [
              `i${i}`
              "selected" if player.song.spriteForChannel(spritePickerChannel()) is i
            ]
          click: ->
            c := spritePickerChannel()
            player.song.setChannelSprite(c, i)

            player.setCursor()

            // Return to showing settings
            Modal.show self.element


  rowViews .= []

  self :=
    showThemeModal: player.showThemeModal
    synthSha: synthSha
    synthOptions: ->
      // TODO: hack, maybe need to fix in Jadelet for when options elements are replaced
      setTimeout ->
        s := self.element.querySelector 'select.synth'
        s.value = synthSha()

      player.soundFontChoices.map ({name, sha}) ->
        OptionTemplate
          name: name
          value: sha

    spriteSha: spriteSha
    spriteOptions: ->
      // TODO: hack, maybe need to fix in Jadelet for when options elements are replaced
      setTimeout ->
        s := self.element.querySelector 'select.sprite'
        s.value = spriteSha()

      player.spritesheetChoices.map ({name, sha}) ->
        OptionTemplate
          name: name
          value: sha

    unmuteAll: ->
      rowViews.forEach (view) ->
        view.active true

    close: -> Modal.hide()
    items: ->
      song := player.song

      player.synthUpdated()
      song.instrumentMapChanged()

      { banks } := player.synth()

      {
        channelActive
        channelBanks
        channelPans
        channelVolumes
        instrumentMap
      } := song

      rowViews = [0...16].map (c) ->
        instruments := banks?[channelBanks[c]]

        active := Observable channelActive[c]
        active.observe (v) ->
          channelActive[c] = v

        program := Observable instrumentMap.get(c)
        program.observe (newValue) ->
          player.setProgram c, parseInt(newValue, 10)

        pan := Observable panToFloat channelPans[c]
        pan.observe (v) ->
          player.setPan c, floatToPan v

        volume := Observable channelVolumes[c] / 127
        volume.observe (v) ->
          player.setVolume c, Math.floor parseFloat(v) * 127

        bankOptions := banks?.map (bank, i) ->
          OptionTemplate
            name: bank.name
            value: i

        programOptions := instruments?.map (instrument, i) ->
          OptionTemplate
            name: instrument.name
            value: i

        me := RowView
          name: `Ch.${c + 1}`
          active: active
          bankOptions: bankOptions
          programOptions: programOptions
          program: program
          pan: pan
          volume: volume
          channelSprite: ->
            i := song.spriteForChannel(c) % player.spriteTextures().length
            `i${i}`
          chooseSprite: ->
            showSpritePicker(c)
          soloChannel: ->
            rowViews.forEach (view) ->
              view.active view is me

      return rowViews

    element: null as! HTMLElement

  self.element = Template self

  return self

export default Settings
